import installationInstructions from './installationInstructions';

const floodlightCategoryContent = {
  installationInstructions
}

export { floodlightCategoryContent };
